import { render, staticRenderFns } from "./ApprovalPass.vue?vue&type=template&id=28544745&scoped=true"
import script from "./ApprovalPass.vue?vue&type=script&lang=js"
export * from "./ApprovalPass.vue?vue&type=script&lang=js"
import style0 from "./ApprovalPass.vue?vue&type=style&index=0&id=28544745&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28544745",
  null
  
)

export default component.exports